import { library, config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import {
  faCogs,
  faToolbox,
  faDiploma,
  faUniversity,
  faCalendar,
  faFolder,
  faHome,
  faCode,
  faBriefcase,
  faFilePdf,
  faUserCircle,
  faMapMarkerAlt,
  faAt,
  faPhone,
  faDoorOpen,
  faHeart,
  faTvRetro,
  faFilm,
  faPlane,
  faGamepad,
  faDraftingCompass,
  faTabletAlt,
  faGlobe,
  faDotCircle,
  faLongArrowRight,
  faCalendarAlt,
  faBuilding,
  faUser,
} from '@fortawesome/pro-light-svg-icons'
import {
  faGithubAlt,
  faLinkedinIn,
  faCss3Alt,
  faHtml5,
  faReact,
  faJs,
} from '@fortawesome/free-brands-svg-icons'

config.autoAddCss = false

const Iconography = () => {
  library.add(
    faGithubAlt,
    faLinkedinIn,
    faCogs,
    faToolbox,
    faCss3Alt,
    faHtml5,
    faReact,
    faJs,
    faDiploma,
    faUniversity,
    faCalendar,
    faFolder,
    faHome,
    faCode,
    faBriefcase,
    faUserCircle,
    faFilePdf,
    faMapMarkerAlt,
    faAt,
    faPhone,
    faDoorOpen,
    faHeart,
    faTvRetro,
    faFilm,
    faPlane,
    faGamepad,
    faDraftingCompass,
    faTabletAlt,
    faGlobe,
    faDotCircle,
    faCalendarAlt,
    faLongArrowRight,
    faBuilding,
    faUser
  )
}

export default Iconography
